// Preload Globals

if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while (i--) y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};


Math.clamp = function (value, min, max) {
    if (value < min) {
        return min;
    }
    else if (value > max) {
        return max;
    }

    return value;
};

Math.lerp = function (value1, value2, amount) {
    return (1 - amount) * value1 + amount * value2;
};

Math.isEven = function (n) {
    return n % 2 == 0;
}

Math.ease = {
    in  :   function(power){return function(t){return Math.pow(t, power)}},
    out :   function(power){return function(t){return 1 - Math.abs(Math.pow(t-1, power))}},
    inOut : function(power){return function(t){return t<.5 ? Math.ease.in(power)(t*2)/2 : Math.ease.out(power)(t*2 - 1)/2+0.5}},

    inElastic: function (t) { return (.04 - .04 / t) * Math.sin(25 * t) + 1 },
    outElastic: function (t) { return .04 * t / (--t) * Math.sin(25 * t) },
    inOutElastic: function (t) { return (t -= .5) < 0 ? (.02 + .01 / t) * Math.sin(50 * t) : (.02 - .01 / t) * Math.sin(50 * t) + 1 },

    inSin: function (t) { return 1 + Math.sin(Math.PI / 2 * t - Math.PI / 2) },
    outSin : function (t) { return Math.sin(Math.PI / 2 * t) },
    inOutSin: function (t) { return (1 + Math.sin(Math.PI * t - Math.PI / 2)) / 2 }
}



var log = {
    enabled: true,
    print: function(msg, tp, tc, mc, btc, bmc, bc, ph, pv, fs){
        if(!this.enabled) return false;
        if(tp == undefined || typeof(tp) != "string") tp = "";
        if(msg == undefined || typeof(msg) != "string") msg = "";
        if(msg == "") return false;
        if(tc == undefined || typeof(tc) != "string") tc = "white";
        if(mc == undefined || typeof(mc) != "string") mc = "white";
        if(btc == undefined || typeof(btc) != "string") btc = "black";
        if(bmc == undefined || typeof(bmc) != "string") bmc = "gray";
        if(bc == undefined || typeof(bc) != "string") bc = "lightgray";
        if(ph == undefined || typeof(ph) != "number") ph = 5;
        if(pv == undefined || typeof(pv) != "number") pv = 2;
        if(fs == undefined || typeof(fs) != "number") fs = 12;

        if(tp==""){
            console.log(`%c${msg}`, `color:${mc};background-color:${bmc};border-left:3px solid ${bc}; padding: ${pv}px ${ph}px; font-family: monospace; font-size:${fs}px;`);
        }else{
            console.log(`%c${tp}%c${msg}`, `color:${tc};background-color:${btc};border-left:3px solid ${bc}; padding: ${pv}px ${ph}px; font-family: monospace; font-weight: bold; font-size:${fs}px;`, `color:${mc};background-color:${bmc}; padding: ${pv}px ${ph}px; font-family: monospace; font-size:${fs}px;`);
        }
        return true;
    },
    webgl: function(msg, lvl){
        if(msg == undefined || typeof(msg) != "string" || msg == "") return false;
        if(lvl == undefined || typeof(lvl) != "number") lvl = 0;
        switch(lvl){
            case 0:{
                this.print(msg, "WebGL:", "MediumVioletRed", "HotPink", "Indigo", "DarkSlateBlue", "DarkSlateBlue");
            }break;
            case 1:{
                this.print(msg, "WebGL:", "MediumVioletRed", "LightSalmon", "Indigo", "Crimson", "Crimson");
            }break;
            case 2:{
                this.print(msg, "WebGL:", "MediumVioletRed", "gray", "darkgray", "lightgray", "gray", 5, 0);
            }break;
        }
        return true;
    },
    page: function(msg, lvl){
        if(msg == undefined || typeof(msg) != "string" || msg == "") return false;
        if(lvl == undefined || typeof(lvl) != "number") lvl = 0;
        switch(lvl){
            case 0:{
                this.print(msg, "Page:", "SteelBlue", "MidnightBlue", "MidnightBlue", "SteelBlue", "SteelBlue");
            }break;
            case 1:{
                this.print(msg, "Page:", "SteelBlue", "LightSalmon", "MidnightBlue", "Crimson", "Crimson");
            }break;
            case 2:{
                this.print(msg, "Page:", "SteelBlue", "gray", "darkgray", "lightgray", "gray", 5, 0);
            }break;
        }
        return true;
    }
}

var showInfo = function(){
    if(!page.three.v.models.loaded){
        console.error("No models loaded to debug");
        return false;
    };
    var obj = {
        godrays:    `${page.three.godRays.enabled?"✔":"❌"} ${page.control.models.godrays._a}`,
        clouds:     `${page.three.clouds.enabled?"✔":"❌"} ${page.control.models.clouds._a}`,
        banga:      `${page.three.banga.visible?"✔":"❌"} ${page.control.models.banga._a}`,
        bangaLand:  `${page.three.bangaLand.visible?"✔":"❌"} ${page.control.models.bangaLand._a}`,
        land:       `${page.three.land.visible?"✔":"❌"} ${page.control.models.land._a}`,
        tree:       `${page.three.tree.visible?"✔":"❌"} ${page.control.models.tree._a}`
    };
    console.table(obj);
    return true;
}